/**
 * API client for the SBA Document Viewer endpoints.
 *
 * Thin re-export layer: every function below delegates to the
 * SBA-bound instance of the shared `createViewerApi` factory
 * (see `createViewerApi.ts` — same factory the EPAR + UK PIL
 * viewers use).  Pre-existing call sites
 * (`import { fetchTOC } from '../api/viewerApi'`) keep working
 * verbatim — only the implementation moved.
 *
 * Type exports (`SectionRefMatch`, `ResolveSectionRefResponse`)
 * are re-exported here too so that consumers don't need to switch
 * their imports.
 */
import { sbaApi } from './createViewerApi';

export type {
  SectionRefMatch,
  ResolveSectionRefResponse,
} from './createViewerApi';
export { buildImageUrl } from './createViewerApi';

// Bind each method onto a module-level name so call sites
// (`import { fetchTOC } from '../api/viewerApi'`) work unchanged.
export const fetchTOC = sbaApi.fetchTOC;
export const fetchPages = sbaApi.fetchPages;
export const fetchTextSpans = sbaApi.fetchTextSpans;
export const fetchBatchTextSpans = sbaApi.fetchBatchTextSpans;
export const fetchChunk = sbaApi.fetchChunk;
export const fetchChunksBatch = sbaApi.fetchChunksBatch;
export const resolveSectionRef = sbaApi.resolveSectionRef;
export const searchDocument = sbaApi.searchDocument;
